import React from 'react'
import { Box } from '@workwhile/ui'
import { FieldglassJobPostingHeader } from './FieldglassJobPostingHeader'
import { FieldglassJobPostingSearchBar } from './FieldglassJobPostingSearchBar'
import { FieldglassJobPostingCards } from './FieldglassJobPostingCards'

export const FieldglassJobPostingMain = () => {
  return (
    <>
      <FieldglassJobPostingHeader />
      <FieldglassJobPostingSearchBar />
      <Box margin={3}>
        <FieldglassJobPostingCards />
      </Box>
    </>
  )
}
